export const PAYPAL_SUPPORTED_CURRENCIES = [
  'USD', 'EUR', 'GBP', 'AUD', 'CAD', 'CHF', 'CZK', 'DKK', 'HKD', 'NOK', 'NZD', 'PLN', 'SEK', 'SGD',
];

export default { PAYPAL_SUPPORTED_CURRENCIES };
